export default "__VITE_ASSET__DifQcpTS__"